/** Collection of common sorting functions for rep/plan lists. */

/** Compare two potentially null or undefined strings. */
export function compareStrings(l, r) {
  if (l == null) {
    return 1;
  }
  if (r == null) {
    return -1;
  }
  return l.localeCompare(r);
}

/** Compare two potentially null or undefined moments. */
export function compareMoments(l, r) {
  return compareNumeric(l, r); // turns out these can be converted to numbers.
}

/** Compare two potentially null or undefined numbers, or types coercible to
 *  numbers (e.g., booleans).
 *
 *  @param l - left side
 *  @param r - right side
 *  @param invertNulls - if true, we'll invert the usual placement of null/undefined values.
 *    use to always force nulls top/bottom.
 */
export function compareNumeric(l, r, invertNulls = false) {
  if (l == null) {
    return r == null ? 0 : invertNulls ? -1 : 1;
  }
  if (r == null) {
    return invertNulls ? 1 : -1;
  }
  return l - r;
}

const invertComparator = <V>(comparator): ((valueA: V, valueB: V) => number) => {
  return (a, b) => {
    const res = comparator(a, b);
    if (res === 0) {
      return 0;
    }

    if (res > 0) {
      return -1;
    }

    return 1;
  };
};

export const getComparator = <ComparedElement, OrderBy extends string = any>(
  orderBy: OrderBy,
  order: 'asc' | 'desc',
  ascComparatorConfig: {
    default: (valueA: ComparedElement, valueB: ComparedElement) => number;
  } & {
    [key in OrderBy]?: (valueA: ComparedElement, valueB: ComparedElement) => number;
  }
) => {
  const comparator = ascComparatorConfig[orderBy] || ascComparatorConfig.default;

  return order === 'asc' ? comparator : invertComparator(comparator);
};
